/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import {
  setSelectedUserNameAction,
  setSelectedAuditStatusAction,
  resetAuditFiltersAction,
  setSelectedFromDateAction,
  setSelectedToDateAction,
} from "./actions";
import { IAuditFilterState } from "../types";


const initialState: IAuditFilterState = {
  selectedUserName: "",
  selectedAuditStatus: "",
};
const auditFilterSlice = createSlice({
  name: "auditFilter",
  initialState,
  reducers: {
    setSelectedUserName: setSelectedUserNameAction,
    setSelectedAuditStatus: setSelectedAuditStatusAction,
    resetAuditFilters: resetAuditFiltersAction,
    setSelectedFromDate: setSelectedFromDateAction,
    setSelectedToDate: setSelectedToDateAction,
  },
});

export const AuditFilterReducer = auditFilterSlice.reducer;
export const { setSelectedUserName, setSelectedAuditStatus, resetAuditFilters, setSelectedFromDate, setSelectedToDate } = auditFilterSlice.actions;
